import React, { useCallback, useEffect, useState } from "react";
import { Avatar, Button, Hidden, IconButton, ListItemIcon, Menu, MenuItem, Stack, Tooltip, Typography } from "@mui/material";
import { FnAxios, FnDialog, I18n, RouterDOM, SecureStorage, stringAvatar } from "utilities/utilities";
import "./Avatar.css";
import { Logout, Loop } from "@mui/icons-material";
import { GetUserAccout, } from "utilities/SystemFunction";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ChangePassword from "../ChangePassword/index";

import { useNavigate } from "react-router";
import { HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
// import DefaultAvatar from "assets/images/NoImage/default-avatar.png";
import DefaultAvatar_FrontEnd from "assets/images/NoImage/user1.png";
import DefaultAvatar from "assets/images/NoImage/user3.png";

const AvatarIcon = (props: IAvatar) => {
    const Router = RouterDOM();
    const DialogFn = FnDialog();
    const navigate = useNavigate();

    const [sName, setsName] = useState(props.sFullName ?? "Admin Admin");

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        let objUser: IAvatar = GetUserAccout();
        let sFullName = props.sFullName ?? objUser?.sFullName;
        setsName(sFullName);
    }, []);

    const handleLogout = () => {
        DialogFn.Submit(I18n.SetText("msgConfirmLogout"), () => {
            DialogFn.CloseSubmit()
            // SecureStorage.Clear();
            // // setTimeout(() => {
            // //     window.location.pathname = `${process.env.PUBLIC_URL}/`;
            // // }, 500);
            // Router.GoToPage("/Home")
            // window.location.reload();

            _sentSignOutHub();
            // SecureStorage.Clear();
            SecureStorage.Remove(process.env.REACT_APP_JWT_KEY);
            // navigate('/Home')
            Router.GoToPage("/Home")
            window.location.reload();
        });
    };

    const [isChangePassword, setisChangePassword] = useState(false);
    const CallChangePassword = useCallback(() => {
        return (
            <>
                {isChangePassword && <ChangePassword isOpen={isChangePassword} setisOpen={setisChangePassword} isChangePasswordLogin={true} />}
            </>
        );
    }, [isChangePassword]);

    const onImageError = (e) => {
        e.target.src = DefaultAvatar;
    }

    const GetAvatar = useCallback(
        () => {
            let objUser: IAvatar = GetUserAccout();
            let sFullName = props.sFullName ?? objUser?.sFullName;
            let sImageUser = props.sImageUser ?? objUser?.sImageUser;
            let sInitials = objUser?.sInitials ?? sFullName;

            if (sFullName || sImageUser || sInitials) {
                return (
                    <Tooltip title={sFullName}>
                        <IconButton className={"btn-avatar"} size="large" disableRipple={true}
                            onClick={(e) => {
                                if (props.isName === false) {
                                    // let ObjbtnAvatar = document.getElementById('btnAvatar');
                                    // ObjbtnAvatar.click();
                                    handleClick(e);
                                }
                            }}
                        >
                            <Avatar className={"avatar"}>
                                {
                                    sImageUser ? 
                                        <img 
                                            src={sImageUser} 
                                            alt={sFullName} 
                                            style={{
                                                objectFit: 'cover',
                                                width: '42px',
                                                height: '42px',
                                            }} 
                                            onError={onImageError}
                                        /> 
                                    : 
                                    <img 
                                        src={props.isName !== false ? DefaultAvatar_FrontEnd : DefaultAvatar} 
                                        alt={sFullName} 
                                        style={{
                                            objectFit: 'cover',
                                            width: '42px',
                                            height: '42px',
                                        }} 
                                    /> 
                                }
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                )
            }
            else {
                return (
                    <Tooltip title={`${I18n.SetText("avatar")}`}>
                        <IconButton className={"btn-avatar"} size="large"
                            onClick={() => {
                                if (props.isName === false) {
                                    let ObjbtnAvatar = document.getElementById('btnAvatar');
                                    ObjbtnAvatar.click();
                                }
                            }}
                        >
                            <Avatar className={"avatar"} />
                        </IconButton >
                    </Tooltip>
                )
            }
        },
        [],
    );

    const GetFullname = useCallback(() => {
        let objUser: IAvatar = GetUserAccout();
        let sFullName = props.sFullName ?? (objUser.sFullName ?? "Admin Admin");
        if (sFullName) {
            return (
                <Stack direction={"column"}>
                    <Typography className="avatar-name" >
                        {sFullName}
                    </Typography>
                </Stack>
            )
        }
        else {
            return (
                <Typography className="avatar-name">
                    {`${I18n.SetText("avatar")}`}
                </Typography>
            )
        }
    }, []);

    //#region Session & Signalr   
    const connection = new HubConnectionBuilder()
    .withUrl(process.env.REACT_APP_API_URL + "hubs/auth")
    .withAutomaticReconnect()
    .build();

    const _sentSignOutHub = () => {
        let objUser: IAvatar = GetUserAccout();
        let nUserID = objUser.nUserID;        
        connection.send("OnSignOutSignal", nUserID, false);
    }
    //#endregion

    return (
        <React.Fragment>
            {/* normal size */}
            <Hidden smDown>
                {
                    <GetAvatar />
                }
                <Button
                    id="btnAvatar"
                    className="avatar-panel"
                    disableElevation
                    onClick={handleClick}
                    endIcon={<KeyboardArrowDownIcon className="avatar-name" />}
                    style={{
                        display: (props.isName !== false ? '' : 'none'),
                    }}
                >
                    <GetFullname />
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    sx={{
                        zIndex:1600
                    }}
                    slotProps={{
                        paper: {
                            elevation: 0,
                            sx: {
                                minWidth: "175px",
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                mt: 1.5,
                                '& .MuiAvatar-root': {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                },
                                '&:before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                    zIndex: 0,
                                }
                            }
                        }
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    {props.isName === false &&
                        <MenuItem disabled>
                            <Typography gutterBottom>{sName}</Typography>
                        </MenuItem>
                    }
                    <MenuItem onClick={() => { setisChangePassword(true); }}>
                        <ListItemIcon>
                            <Loop fontSize="small" />
                        </ListItemIcon>
                        {I18n.SetText("changepassword")}
                    </MenuItem>
                    <MenuItem onClick={handleLogout}>
                        <ListItemIcon>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        {I18n.SetText("logout")}
                    </MenuItem>
                </Menu>
                <CallChangePassword />
            </Hidden>

            {/* phone size */}
            <Hidden smUp>
                {
                    <GetAvatar />
                }
            </Hidden>
        </React.Fragment>
    )
}
export default AvatarIcon;